import { useEffect, useState } from 'react';
import { VideoElement } from '@app/common';
import { getDataUrl } from '../../../../services/MediaFileService/MediaFileService';
import { useAppSelector } from 'src/store/hooks';

type Properties = {
    data: VideoElement;
};

const Video = (props: Properties) => {
    const [videoFile, setVideoFile] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const studyId = useAppSelector(state => state.globalState.user?.studyId);
    const caption = props.data.caption || '';

    useEffect(() => {
        setIsLoading(true);

        const loadVideo = async () => {
            try {
                const dataUrl = await getDataUrl(props.data.id, studyId);
                setVideoFile(dataUrl);
            } catch (e) {
                console.error('Video ' + props.data.id + ' could not be loaded: ' + e);
            } finally {
                setIsLoading(false);
            }
        };
        loadVideo();

        return () => {
            setVideoFile('');
        };
    }, [props.data.id]);

    let content: JSX.Element;
    if (isLoading) {
        content = (<p className="media-loading">Video wird geladen...</p>);
    } else if (!videoFile) {
        content = (<p>Videodatei {props.data.id} nicht gefunden.</p>);
    } else {
        content = (
            <video controls={true} autoPlay={props.data.autoplay}>
                <source src={videoFile} />
            </video>
        );
    }

    return (
        <div className="page-video">
            {caption && <h2>{caption}</h2>}
            {content}
        </div>
    );
};

export default Video;
